import View from 'client/components/common/BuildingBlocks/Content/Content';
import model from 'client/components/common/BuildingBlocks/Content/model';

export const CONTENT = () => ({
	view: View,
	get model() {
		return model();
	},
});
